const solarTechnicianService = {
  title: "Solar Technician",
  icon: "☀️",
  shortDescription:
    "Solar panel support, wiring checks, inverter-side review, and maintenance visits.",
  longDescription:
    "Book solar support for inspection, installation assistance, minor troubleshooting, and maintenance-related work.",
  consultationNote:
    "Capacity sizing, roof layout, and full installation estimate should begin with inspection.",
  responsePromise:
    "Assignment depends on roof context, access, and technician specialization.",
  warrantyPolicy:
    "Support depends on system condition, manufacturer context, and job type.",
  subServices: [
    {
      id: "solar-panel-cleaning-check",
      title: "Solar Panel Cleaning / Check",
      icon: "🧼",
      group: "Maintenance",
      description:
        "Basic cleaning and performance-side visual check for solar panel surface condition.",
      basePrice: 699,
      priceType: "starts_at",
      duration: "45-90 mins",
      warranty: "Service completion",
      unit: "job",
    },
    {
      id: "solar-wiring-inspection",
      title: "Solar Wiring Inspection",
      icon: "🧵",
      group: "Inspection",
      description:
        "Inspect visible wiring route and connection-side issues in solar setup.",
      basePrice: 499,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "solar-inverter-check",
      title: "Solar Inverter Check",
      icon: "🔋",
      group: "Inspection",
      description:
        "Inspect inverter-side warning, output issue, or basic system behavior concern.",
      basePrice: 499,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "solar-installation-inspection",
      title: "Solar Installation Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for rooftop solar planning, quote preparation, and execution feasibility.",
      basePrice: 599,
      priceType: "inspection",
      duration: "30-60 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default solarTechnicianService;